import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import ReservationConfirmationResult from '@/models/interfaces/ReservationConfirmationResult';
import {
  confirmReservation,
  ConfirmReservationActionType,
  reservationConfirmationFailed,
  reservationConfirmationFinished,
} from '@/store/actions/reservation/confirmReservation';

import { fromDto } from '../../../models/adapters/ReservationConfirmationResultAdapter';
import getPublicResponse from '../getPublicResponse';

function* confirmReservationSaga({ payload }: ConfirmReservationActionType) {
  const timestamp = moment();
  const { token, action } = payload;
  const response = yield getPublicResponse(PublicServerPlaceEvent.confirmReservation, {
    token,
    action,
  });
  const { reservationConfirmationResult, error } = response;
  if (error) {
    const action = reservationConfirmationFailed({
      token,
      reservationConfirmationResult: ReservationConfirmationResult.failed,
      timestamp,
    });
    yield put(action);
  } else {
    const action = reservationConfirmationFinished({
      token,
      reservationConfirmationResult: fromDto(reservationConfirmationResult),
      timestamp,
    });
    yield put(action);
  }
}

export default function* watchConfirmReservationSaga() {
  yield takeEvery(confirmReservation, confirmReservationSaga);
}
